import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { domainDetails } from "../domainDetails"
import useIsMobile from './isMobile';

export default function TopBar() {
    let host = window.location.host;
    const subdomain = host.split('.')[0];
    const currentDomain = domainDetails[subdomain];
    const headerConfig = currentDomain?.header;

    const isMobile = useIsMobile();

    return (
        <Box sx={{ width: '100%' }}>
            <AppBar
                position="static"
                elevation={0}
                
                sx={{
                    bgcolor: headerConfig?.bgcolor || '#fff',
                    borderBottom: `1px solid ${headerConfig?.borderColor ?? 'rgba(0,0,0,0.08)'}`,
                    color: headerConfig?.color || 'inherit',
                    borderRadius:0
                }}
            >
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }} component='a' href='/'>
                        <img
                            hidden={['tracking', 't'].includes(subdomain)}
                            src={currentDomain ? currentDomain.logo : domainDetails.default.logo}
                            height={isMobile ? 20 : 30}
                            style={{
                                margin: '10px',
                                cursor: currentDomain?.webUrl ? 'pointer' : 'default',
                                ...(currentDomain?.style || {})
                            }}
                            onClick={() => {
                                if (currentDomain?.webUrl) {
                                    window.open(currentDomain.webUrl, '_blank');
                                }
                            }}
                            alt="logo"
                        />
                    </Box>
                    <Typography
                        variant={isMobile ? 'caption' : 'body2'}
                        sx={{ color: headerConfig?.color || 'text.secondary', display: 'flex', alignItems: 'center' }}
                        fontWeight={500}
                    >
                        Powered by <img style={{ marginLeft: 8 }} src="/img/prozo.png" height={isMobile ? 15 : 25} alt="logo" />
                    </Typography>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
